import { Layout, CtaForm } from '../../components';
import { CheckboxFeature, FeatureIcon } from '../../components/Svg';
import { FACILITY_BOT_ACADEMY_LINK } from '../../constants';

export default function Academy() {
	return (
		<Layout pageName='FacilityBot Academy'>
			<div className='resource-page resource-page--partner'>
				<section className='heading-container'>
					<div className='container'>
						<div className='heading'>
							<h1 className='heading__title'>FacilityBot Academy</h1>

							<h2 className='heading__desc'>
								Be recognized as a digitally-savvy Facilities Manager by
								enrolling in our FREE virtual academy, and become certified by
								completing courses!
							</h2>
						</div>
					</div>
				</section>

				<section className='instructions'>
					<div className='container instructions__wrapper'>
						<div className='instructions__left-side'>
							<h3 className='instructions__heading'>Who should enroll?</h3>
							<div className='instructions__desc'>
								The Academy is for Facilities Management professionals who are
								seeking to advance their careers in this digital age. By
								becoming familiar with FacilityBot's easy-to-use and
								easy-to-deploy smart FM system, participants of the courses can
								quickly become recognized as digitally-savvy facilities
								managers.
							</div>
							<br />
							<div className='instructions__desc'>
								NOTE: Courses are FREE even for persons not currently using
								FacilityBot in their work environments.
							</div>
						</div>

						<div className='instructions__right-side'>
							<div className='instructions__question-title'>
								Do these sound like you?
							</div>

							<Instructions />
						</div>
					</div>
				</section>

				<section className='benefits'>
					<div className='container benefits__wrapper'>
						<h2 className='benefits__heading'>What to expect by enrolling</h2>

						<Benefits />
					</div>
				</section>

				<section className='marketing'>
					<div className='container' style={{ textAlign: 'center' }}>
						<button className='btn btn--plans'>
							<a href={FACILITY_BOT_ACADEMY_LINK}>
								start your learning journey now
							</a>
						</button>
					</div>
				</section>

				<CtaForm />
			</div>
		</Layout>
	);
}

const Instructions = () => {
	const instructions = [
		'Interested in gaining a competitive edge and future-proofing your skills in the FM industry',
		'Looking to implement Smart FM / Building Management solutions but not sure where to begin',
		'Would like to learn how to digitize manual processes and get started with a Smart FM system',
		'Already using FacilityBot and would like to improve by undergoing a structured course',
	];

	return (
		<ul className='instructions__question-list'>
			{instructions.map((item, index) => (
				<li className='instructions__question-item'>
					<div className='item__icon'>
						<CheckboxFeature />
					</div>
					<span className='item__text'>{item}</span>
				</li>
			))}
		</ul>
	);
};

const Benefits = () => {
	const benefits = [
		{
			icon: 51,
			title: 'Self-Paced',
			desc: 'All of our courses are self-paced, so you can start and finish whenever you like !',
		},
		{
			icon: 6,
			title: 'Video Tutorials',
			desc: 'Courses consist of a series of video tutorials that walk you through all the steps needed to become a FacilityBot administrator.',
		},
		{
			icon: 35,
			title: 'Completion Quiz',
			desc: 'Attempt a quiz after going through the video tutorials to reinforce your knowledge.',
		},
		{
			icon: 52,
			title: 'Certificate and Badge',
			desc: 'Obtain a digital certificate and badge once upon successful course completion which you can share with friends and colleagues.',
		},
	];

	return (
		<div className='benefits__list'>
			{benefits.map((item, index) => (
				<div className='benefits__item' key={index}>
					<div className='benefits__icon'>{FeatureIcon(item.icon)}</div>
					<div className='benefits__content'>
						<h5 className='benefits__title'>{item.title}</h5>
						<div className='benefits__desc'>{item.desc}</div>
					</div>
				</div>
			))}
		</div>
	);
};
